module.exports = __webpack_public_path__ + "img/03.9c6fce4c.png";